import { Buffer } from "buffer";          // polyfill first
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

window.Buffer = Buffer;                   // attach after imports

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
